import React from 'react'
import { connect } from 'react-redux'
import { postFinishChallengeById } from 'services/challenges'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import ErrorModal from './ErrorContainer'
import SuccessModal from './SuccessContainer'

const mapStateToProps = () => ({
  title: i18n.t('CONFIRMATION_MESSAGE'),
  description: i18n.t('CHALLENGES.FINISH_ASK'),
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    mainButtonAction: () => {
      const onSuccess = () => {
        showPopupDialog(<SuccessModal description={i18n.t('CHALLENGES.FINISH_OK')} />, dispatch)
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorModal description={i18n.t(messageTag)} />, dispatch)
      }
      dispatch(postFinishChallengeById(ownProps.id, onSuccess, onFailure))
      dispatch(hideDialog())
      dispatch(Navigation.navigateToChallenges())
    },
    cancelButtonAction: () => dispatch(hideDialog()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
